import { render, staticRenderFns } from "./DialogCreateTemplate.vue?vue&type=template&id=2f0709ed&scoped=true"
import script from "./DialogCreateTemplate.vue?vue&type=script&lang=js"
export * from "./DialogCreateTemplate.vue?vue&type=script&lang=js"
import style0 from "./DialogCreateTemplate.vue?vue&type=style&index=0&id=2f0709ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0709ed",
  null
  
)

export default component.exports